import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { POINT_PAGE_NAME } from '../../constants/service/app/pointConstants';
import PointReferralIssueListContainer from '../../containers/point/PointReferralIssueListContainer';

const PointReferralIssueList = () => {
  return (
    <PageTemplate pageName={POINT_PAGE_NAME.POINT_REFERRAL_ISSUE_LIST}>
      <PointReferralIssueListContainer />
    </PageTemplate>
  );
};

export default PointReferralIssueList;
